// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/core-js/library/modules/_descriptors.js
// module id = 66
// module chunks = 0